module.exports = __webpack_public_path__ + "img/icon-happy.89cfbfe9.svg";